export default __webpack_public_path__ + "static/media/guesty_lite_step10.0f91d983.png";